import React, { useEffect, useState } from "react";
import { TextField, MenuItem, Typography } from "@mui/material";
import { useGetContragentsQuery } from "../../../store/contragentApi";
import InputAdornment from "@mui/material/InputAdornment";
import styled from "styled-components"
import Modal from "../../UI/Modal";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import FlexContainer from "../../UI/FlexContainer";
import Contragenty from "../../spravochniki/contragent/Contragenty";
import BasicButtons from "../../UI/BasicButtons";
import PaymentTable from "./PaymentTable";
import {
  paymentFilter,
  scheduleFilter,
} from "../../../utilits/getTotalPayment";
import { useGetPaymentCodeQuery } from "../../../store/paymentCodeApi";
import { convertToRuFormat } from "../../../utilits/helpers/convertDateFormat";
import DogovorTable from "./DogovorTable";
import InfoContragent from "./InfoContragent";

const ContragentRep = () => {
  const { data: contragentFB } = useGetContragentsQuery(
    "?populate[0]=dogovors.payments.payment_code&populate[1]=dogovors.nomenklatura",
    { refetchOnMountOrArgChange: true }
  );
  const { data: paymentCodeFB } = useGetPaymentCodeQuery();
  const [selectedContragent, setSelectedContragent] = useState("");
  const [modalForContragenty, setModalForContragenty] = useState(false);
  const [contragents, setContragents] = useState([]);
  const [findedContragent, setFindedContragent] = useState({
    attributes: {
      address: "",
      birthday: "",
      inn: "",
      lastname: "",
      name: "",
      passport: "",
      phone: "",
      surname: "",
    },
  });
  const [paymentCodes, setPaymentCodes] = useState([]);
  const [dogovors, setDogovors] = useState([]);
  const [dogovorID, setDogovorID] = useState("all");
  const [selectedDogovors, setSelectedDogovors] = useState([]);
  const [invoiceArenda, setInvoiceArenda] = useState([]);
  const [invoiceNalog, setInvoiceNalog] = useState([]);
  const [paymentArenda, setPaymentArenda] = useState([]);
  const [paymentNalog, setPaymentNalog] = useState([]);
  const paymentCodeArenda = paymentCodes.find((item) => item.id === 1);
  const paymentCodeNalog = paymentCodes.find((item) => item.id === 2);

  const handleClickGenerateReport = () => {
    if (dogovorID === "all") {
      const invoiceArenda = dogovors.map((dogovor) => {
        const scheduleTotal = scheduleFilter(dogovor.attributes.schedule);
        return scheduleTotal;
      });
      const invoiceNalog = dogovors.map((dogovor) => {
        const scheduleTotal = scheduleFilter(dogovor.attributes.scheduleNalog);
        return scheduleTotal;
      });
      setInvoiceArenda(invoiceArenda);
      setInvoiceNalog(invoiceNalog);
      const paymentArenda = dogovors.map((dogovor) => {
        const paymentTotal = paymentFilter(
          dogovor.attributes.payments.data,
          paymentCodeArenda.attributes.code
        );
        return paymentTotal;
      });
      const paymentNalog = dogovors.map((dogovor) => {
        const paymentTotal = paymentFilter(
          dogovor.attributes.payments.data,
          paymentCodeNalog.attributes.code
        );
        return paymentTotal;
      });
      setPaymentArenda(paymentArenda);
      setPaymentNalog(paymentNalog);
      setSelectedDogovors(dogovors);
    } else {
      const selectedDogovor = dogovors.find(
        (dogovor) => dogovor.id === dogovorID
      );
      const selectedInvoceArenda = scheduleFilter(
        selectedDogovor.attributes.schedule
      );
      const selectedInvoiceNalog = scheduleFilter(
        selectedDogovor.attributes.scheduleNalog
      );
      const selectedPaymentArenda = paymentFilter(
        selectedDogovor.attributes.payments.data,
        paymentCodeArenda.attributes.code
      );
      const selectedPaymentNalog = paymentFilter(
        selectedDogovor.attributes.payments.data,
        paymentCodeNalog.attributes.code
      );
      setInvoiceArenda([selectedInvoceArenda]);
      setInvoiceNalog([selectedInvoiceNalog]);
      setPaymentArenda([selectedPaymentArenda]);
      setPaymentNalog([selectedPaymentNalog]);
      setSelectedDogovors([selectedDogovor]);
    }
  };

  useEffect(() => {
    const setData = async () => {
      try {
        const contragentTemp = await contragentFB.data;
        const paymentCodeTemp = await paymentCodeFB.data;
        setContragents(contragentTemp);
        setPaymentCodes(paymentCodeTemp);
      } catch (error) {}
    };
    setData();
  }, [contragentFB, paymentCodeFB]);

  const getContragentItem = (selectedItem) => {
    setSelectedContragent(
      selectedItem.attributes.surname +
        " " +
        selectedItem.attributes.name +
        " " +
        selectedItem.attributes.lastname
    );
    const findedItem = contragents.find((item) => item.id === selectedItem.id);
    setDogovors(findedItem.attributes.dogovors.data);
    setFindedContragent(selectedItem);
    setDogovorID("all");
    setInvoiceArenda([]);
    setInvoiceNalog([]);
    setPaymentArenda([]);
    setPaymentNalog([]);
    setSelectedDogovors([]);
  };

  const handleClickSelect = (item) => {
    setInvoiceArenda([]);
    setInvoiceNalog([]);
    setPaymentArenda([]);
    setPaymentNalog([]);
    setSelectedDogovors([]);
    setDogovorID(item.id);
  };

  return (
    <>
      <TitleStyled>
        <h2 style={{marginBottom: "0"}}>Отчет по контрагенту на: {convertToRuFormat(new Date())} года</h2>
      </TitleStyled>
      <FlexContainer width={"70%"} margin={"10px auto"} gap="20px">
        <TextFieldStylded
          InputLabelProps={{ shrink: true }}
          label="Контрагент"
          id="outlined-end-adornment"
          mrg="0 20px 0 0"
          size="small"
          width="35%"
          value={selectedContragent}
          onChange={(event) => setSelectedContragent(event.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconStyled
                  onClick={() => setModalForContragenty(true)}
                  color="primary"
                />
              </InputAdornment>
            ),
          }}
        />
        <Modal
          fullwidth={"60%"}
          isOpen={modalForContragenty}
          onClose={() => setModalForContragenty(false)}
        >
          <Contragenty
            onCloseContragenty={() => setModalForContragenty(false)}
            getContragentItem={getContragentItem}
          />
        </Modal>

        <TextFieldStylded
          id="select"
          select
          label="Договора"
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          variant="outlined"
          size="small"
          value={dogovorID}
          width="34%"
        >
          {dogovors.map((item) => {
            return (
              <MenuItem
                key={item.id}
                value={item.id}
                onClick={() => handleClickSelect(item)}
              >
                Договор №{item.attributes.numberDogovor} от{" "}
                {convertToRuFormat(item.attributes.docDate)}
              </MenuItem>
            );
          })}
          <MenuItem value={"all"} onClick={() => setDogovorID("all")}>
            Все договора
          </MenuItem>
        </TextFieldStylded>

        <BasicButtons margin={"0"} onClick={handleClickGenerateReport}>
          Сформировать
        </BasicButtons>
      </FlexContainer>
      <FlexContainer justifyContent={"space-between"} margin={"0 5px"} responsive>
        <div style={{ width: "50vw", margin: "8px", padding: "8px" }}>
          <Typography variant="h6" align="center">
            Информация о контрагенте
          </Typography>
          <InfoContragent item={findedContragent} />
        </div>
        <div style={{ width: "50vw", margin: "8px", padding: "8px" }}>
          <Typography variant="h6" align="center">
            Информация по оплатам
          </Typography>
          <PaymentTable
            invoiceArenda={invoiceArenda}
            invoiceNalog={invoiceNalog}
            paymentArenda={paymentArenda}
            paymentNalog={paymentNalog}
          />
        </div>
      </FlexContainer>
      <div style={{ margin: "10px 0" }}>
        <Typography variant="h5" align="center">
          Информация по договорам
        </Typography>
        <DogovorTable rows={selectedDogovors} />
      </div>
    </>
  );
};

export default ContragentRep;

const TextFieldStylded = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;
const IconStyled = styled(MoreHorizTwoToneIcon)`
  cursor: pointer;
`;
const TitleStyled = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;
